import React, { useState } from 'react';
// template imports
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// helpers
import GeocoderService from '@nmx/utils-frontend/dist/utilities/frontend/geocoderService';
// native components
import FRSearchInput from '../frSearchInput/frSearchInput';
import LocationSearchInput from '../locationSearchInput';
// styles
import {
  ButtonStyled,
  FormStyledSearchDirectory,
} from './styles';

export default () => {

  const [name, setName] = useState();
  const [location, setLocation] = useState({
    address: '',
    lat: '',
    lng: '',
  });

  let target = '/financial-professionals/';

  const getLocation = (loc) => {
    setLocation(loc);
  };

  // update last name as they type
  const handleOnChangeName = (e) => {
    const newName = (e.target || e.srcElement || {}).value;
    setName(newName);
  };

  const getLatitudeAndLongitudeFromAddress = () => {
    return new Promise((resolve) => {
      if (location && location.description && !location.lat && !location.lng) {
        GeocoderService
          .promiseGeocode(location.description).then((geocodedLocation) => {
            if (geocodedLocation) {
              // eslint-disable-next-line no-param-reassign
              geocodedLocation.description = location.description;
              setLocation(geocodedLocation);
            }
            // else {
            //   setLocation(location); // failed to get lat lng, update location accordingly
            // }
            resolve();
          }).catch(() => {
            console.error(`Error getting reps with location: ${location.description}.`);
            resolve();
          });
      } else {
        resolve();
      }
    });
  };

  const submitForm = (event) => {
    event.preventDefault();
    event.stopPropagation();

    getLatitudeAndLongitudeFromAddress().then(() => {
      // Otheriwse do URL manipulation
      const params = [];

      if (location.description) {
        params.push(`address=${escape(location.description)}`);
      }

      if (location.lat) {
        params.push(`lat=${escape(location.lat)}`);
      }

      if (location.lng) {
        params.push(`lng=${escape(location.lng)}`);
      }

      if (name) {
        params.push(`name=${escape(name)}`);
      }

      params.push('page=1');

      target += target.indexOf('?') > -1 ? '&' : '?';
      target += params.join('&');

      window.location.href = target;

    }).catch((err) => {
      console.error(`Unable to complete search: ${err ? err.error || err.message : ''}`);
    });
  };

  return (
    <SectionContainer
      id='search'
      className='js-hide-on-submit'
      backgroundVariant='lightC'
      themeType='lightTheme'>
      <Row align='center'>
        <Col align='center'>
          <Typography
            component='h2'
            align='center'
            disableBottomPadding>
            Looking for a different advisor or location&#63;
          </Typography>
        </Col>
      </Row>
      <Row align='center'>
        <Col align='center'>
          <FormStyledSearchDirectory
            className='nm-search-directory-form'
            id='nm-search-directory-form'
            role='search'
            onSubmit={submitForm}>
            <Row align='center'>
              <Col align='center'>
                {/* note: these can be AURA TextField Components */}
                <FRSearchInput
                  label='First or Last Name'
                  defaultValue={name}
                  id='nm-search-directory-form-name-input'
                  onChange={handleOnChangeName}
                />
                <LocationSearchInput
                  label='Location'
                  defaultValue={location.description}
                  id='nm-search-directory-form-location-input'
                  locationCallback={getLocation}
                />
                <ButtonStyled
                  id='nm-search-directory-form-submit-button'
                  name='search'
                  variant='primary'
                  ariaLabel='See our tips about your first financial advisor meeting'
                  type='submit'>
                  Search
                </ButtonStyled>
              </Col>
            </Row>
          </FormStyledSearchDirectory>
        </Col>
      </Row>
    </SectionContainer>
  );
};
